export enum CompanyPermissionOptions {
    ViewAllSites = 'View All Sites',
    ViewEditSomeSites = 'View/Edit Some Sites',
    EditAllSites = 'Edit All Sites'
}